import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Observable } from 'rxjs';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';
import { ITemplate } from '../models/template';
import { instanceOfITemplateColumn } from '../models/tp-col';

const TRANSLATION_TYPES = {
  Order: 'Serviceauftrag',
  'Reporting::DamageReport': 'Schadensbericht',
  'ChecklistManagement::WriteableChecklist': 'Checkliste',
};

const NESTED_ATTRIBUTE_KEYS = [
  'rows',
  'cols',
  'element_style',
  'module',
  'border',
  'border_radius',
  'border_type',
  'border_color',
  'border_weight',
  'padding',
  'margin',
  'title_text_style',
  'body_text_style',
];

@Injectable({
  providedIn: 'root',
})
export class TemplateService extends OfflineDataService<ITemplate> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'TemplateManagement::Document',
      http,
      errorService,
      events,
      'reporting/documents/',
      'document',
      ['created_at', 'updated_at', 'created_by_id'],
      []
    );
  }

  /**
   * Übersetzt einen type
   * @param {string} type
   * @return {string}
   */
  public static translateType(type: string): string {
    return TRANSLATION_TYPES[type as keyof typeof TRANSLATION_TYPES];
  }

  /**
   * Übersetzungen zurückgeben
   * @return {Record<string,string>}
   */
  public static get translations(): Record<string, string> {
    return TRANSLATION_TYPES;
  }

  /**
   * Speichern überladen und Objekt streamlinen bevor es versendet wird
   * @param {ITemplate} object
   * @return {Observable<ITemplate>}
   */
  public override saveRemote(object: ITemplate, queueId: string|null = null): Observable<ITemplate> {
    const mappedObject = this.mapAndFilterObject(object);
    return super.saveRemote(mappedObject, queueId);
  }

  /**
   * Object Streamlinen
   * @param obj to map and filter
   * @return finished object
   */
  private mapAndFilterObject(obj: ITemplate): ITemplate {
    if (!obj) return obj;
    // Streamlining traversiert das Objekt dynamisch über seine Keys.
    const record = obj as unknown as Record<string, unknown>;
    for (const k of Object.keys(obj)) {
      const value = record[k];
      if (typeof value === 'object' && value !== null) {
        // Checks if Type is Column and if it is and the Column has no element or rows it gets deleted
        if (instanceOfITemplateColumn(value)) {
          if (!value.module && (!value.rows || value.rows.length <= 0)) {
            delete record[k];
          }
        }
        this.mapAndFilterObject(value as ITemplate);
      }
      this.checkAndAddAttributed(obj, k);
    }
    return obj;
  }

  /**
   * Checks if and applies 'attributes' to obj attribute k
   * @param obj obj to check
   * @param k key to check
   */
  private checkAndAddAttributed(obj: any, k: string) {
    if (NESTED_ATTRIBUTE_KEYS.includes(k)) {
      const v = obj[k];
      delete obj[k];
      obj[k + '_attributes'] = v;
    }
  }
}
